import { watch } from 'vue';
import sessionService from '@/services/SessionService';

import { aplicarMenuSeuFocoAgora } from './seuFocoAgoraLayout';

/**
 * A folha entra por aqui, e não pela home: a classe do header é aplicada em todas as rotas, e a
 * home é lazy. Importada lá, quem entrasse direto no checkout ficaria com a classe no `<body>` e
 * sem CSS — o header só viraria kebab depois da primeira visita à home.
 */
import './seuFocoAgoraLayout.scss';

/**
 * Mantém a classe do header no `<body>` em sincronia com a sessão: o token pode chegar depois do
 * primeiro paint ou trocar com login/logout. Deslogado, o header continua o de sempre. Chamado uma
 * vez em `App.vue`.
 */
export function useMenuSeuFocoAgora(): void {
  watch(() => sessionService.isLoggedIn, aplicarMenuSeuFocoAgora, { immediate: true });
}
